import axios from 'axios';
import { Request, RequestMetadata, DocumentType } from '../types/request';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.usesieve.com';

class RequesterService {
  async getRequests(): Promise<Request[]> {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await axios.get<Request[]>(`${API_BASE_URL}/api/v1/jobs`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true
      });

      return response.data;
    } catch (error: any) {
      console.error('Error fetching requests:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch requests');
    }
  }

  async submitRequest(documentType: DocumentType, metadata: RequestMetadata, AI_only: boolean = false): Promise<{ job_id: string }> {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await axios.post<{ job_id: string }>(
        `${API_BASE_URL}/api/v1/process`,
        {
          document_type: documentType,
          metadata,
          AI_only
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          withCredentials: true
        }
      );

      return response.data;
    } catch (error: any) {
      console.error('Error submitting request:', error);
      throw new Error(error.response?.data?.message || 'Failed to submit request');
    }
  }
}

export const requesterService = new RequesterService();
